/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Row, Col, Button, Modal } from "react-bootstrap";
import axios from "axios";
//Icon Library
import {
  MdStars,
  MdSearch,
  MdCreditCard,
  MdCancel,
  MdReceipt,
  MdOutlineCancel,
  MdModeEditOutline,
  MdCheckCircle,
} from "react-icons/md";
//TimeRendering
import Moment from "react-moment";
//Common
import FadeIn from "../../common/FadeIn";
import StatusBlock from "../../common/StatusBlock";
//Router
import { Link } from "react-router-dom";

const ParticipantManageBlock = (props) => {
  const [cancellationIsOpen, setCancellationIsOpen] = useState(false);
  const [detailsView, setDetailsView] = useState(false);
  const [cancellingSub, setCancellingSub] = useState("");
  const [cancellingBlock, setCancellingBlock] = useState("");
  const [blockCancellationIsOpen, setBlockCancellationIsOpen] = useState(false);
  // Filter to the correct Participant Data and other stuff from props.
  const participant = props.customer.Participants.find((x) => {
    return x._id === props.selectedParticipant;
  });
  const currentKey = props.updateKey;
  // Handle Column Amounts
  let largeCols;
  if (participant.Subscriptions.length === 1) {
    largeCols = "12";
  } else if (participant.Subscriptions.length === 2) {
    largeCols = "6";
  } else if (participant.Subscriptions.length === 3) {
    largeCols = "4";
  } else {
    largeCols = "3";
  }

  let largeColsBlock;
  if (participant.BlockClasses.length === 1) {
    largeColsBlock = "12";
  } else if (participant.BlockClasses.length === 2) {
    largeColsBlock = "6";
  } else if (participant.BlockClasses.length === 3) {
    largeColsBlock = "4";
  } else {
    largeColsBlock = "3";
  }

  let largeColsWaiting;
  if (participant.WaitingList.length === 1) {
    largeColsWaiting = "12";
  } else if (participant.WaitingList.length === 2) {
    largeColsWaiting = "6";
  } else if (participant.WaitingList.length === 3) {
    largeColsWaiting = "4";
  } else {
    largeColsWaiting = "3";
  }

  // Self Cancellation on or off
  const selfCancellation = props.selfCancellation;

  // Cancel Subscription
  const cancelBlock = async (e) => {
    e.preventDefault();
    const deleteSubscriptionRequest = await axios.delete(
      `/api/customer/manage_subscription/delete_block`,
      { data: cancellingBlock },
      {
        withCredentials: true,
      }
    );
    if (deleteSubscriptionRequest.status === 200) {
      setBlockCancellationIsOpen(false);
      props.setSuccessMessage("Successfully left block booking");
      return setTimeout(() => {
        props.setUpdateKey(currentKey + 1);
        props.setSubmitClicked(false);
      }, 1000);
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage(
        "There was an error  - please contact support if it persists."
      );
    }
  };

  // Cancel Subscription
  const cancelSubscription = async (e) => {
    e.preventDefault();
    const deleteSubscriptionRequest = await axios.delete(
      `/api/customer/manage_subscription/delete_subscription`,
      { data: { stripe_subscription_id: cancellingSub } },
      {
        withCredentials: true,
      }
    );
    if (deleteSubscriptionRequest.status === 200) {
      setCancellationIsOpen(false);
      props.setSuccessMessage("Successfully initiated cancellation");
      return setTimeout(() => {
        props.setUpdateKey(currentKey + 1);
        props.setSubmitClicked(false);
      }, 1000);
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage(
        "There was an error  - please contact support if it persists."
      );
    }
  };

  // Cancel Subscription
  const cancelWaitingList = async (_id, e) => {
    e.preventDefault();
    const deleteWaitingList = await axios.delete(
      `/api/customer/customer_general/waiting_list_delete`,
      { data: { _id } },
      {
        withCredentials: true,
      }
    );
    if (deleteWaitingList.status === 200) {
      setCancellationIsOpen(false);
      props.setSuccessMessage("Successfully deleted waiting list entry.");
      props.setUpdateKey(currentKey + 1);
      return props.setSubmitClicked(false);
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage(
        "There was an error  - please contact support if it persists."
      );
    }
  };

  // Change Card Subscription
  const handleCardChange = async (stripe_subscription_id, e) => {
    e.preventDefault();
    const data = {
      stripe_subscription_id,
    };
    const changeCardSession = await axios.post(
      `/api/customer/manage_session/change_card_details/`,
      data,
      {
        withCredentials: true,
      }
    );
    if (changeCardSession.status === 200) {
      props.setSubmitClicked(false);
      return (window.location.href = changeCardSession.data.url);
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage(
        "There was an error - please contact support if it persists."
      );
    }
  };

  return (
    <FadeIn delay={250} duration={450}>
      <Row>
        <div className="text-center mt-2 mb-2">
          <Button
            variant="secondary"
            onClick={() => props.setViewMode("view")}
            type="button"
          >
            <MdOutlineCancel />
            Return
          </Button>
        </div>
        <Col sm="12">
          <div className="shadow mt-4 p-3 border text-center">
            <h3>{`${participant.First_Name} ${participant.Last_Name}`}</h3>
            {!detailsView && (
              <Button
                variant="secondary"
                size="sm"
                onClick={() => setDetailsView(true)}
                type="button"
                className="mb-1 mt-1"
              >
                Edit / View Details
              </Button>
            )}
            {detailsView && (
              <>
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={() => setDetailsView(false)}
                  type="button"
                  className="mb-1 mt-1"
                >
                  Close Details
                </Button>
                <h5>Age</h5>
                <Moment format="Y [year], M [months]" durationFromNow ago>
                  {participant.Date_Of_Birth}
                </Moment>{" "}
                old
                <br />
                <span className="smallprint">{participant.Date_Of_Birth}</span>
                <hr />
                <h5>Emergency Contact 1</h5>
                <a
                  href={`tel:${participant.Emergency_Contact_1_Contact_Number}`}
                >
                  {participant.Emergency_Contact_1_Contact_Number}
                </a>
                <br />
                <span className="smallprint">
                  {participant.Emergency_Contact_1_Name}
                </span>
                <hr />
                <h5>Emergency Contact 2</h5>
                <a
                  href={`tel:${participant.Emergency_Contact_2_Contact_Number}`}
                >
                  {participant.Emergency_Contact_2_Contact_Number}
                </a>
                <br />
                <span className="smallprint">
                  {participant.Emergency_Contact_2_Name}
                </span>
                <hr />
                <h5>Address</h5>
                <span>{participant.Address}</span>
                {participant.Special_Requirements !== "" && (
                  <>
                    <hr />
                    <h5>Special Requirements</h5>
                    <span className="smallprint">
                      {participant.Special_Requirements}
                    </span>
                  </>
                )}
                <hr />
                <Button
                  variant="info"
                  className="w-100 mt-2 mb-2"
                  type="button"
                  onClick={() => props.setViewMode("editParticipant")}
                >
                  Not Correct? <MdModeEditOutline />
                </Button>
              </>
            )}
            {participant.ReportCards.length > 0 && (
              <Button
                variant="primary"
                className="w-100 mt-2 mb-2"
                type="link"
                as={Link}
                to={`/participant-progress/${participant._id}`}
              >
                Progress <MdReceipt />
              </Button>
            )}
            {participant.Awards.length > 0 && (
              <Button
                variant="success"
                className="w-100 mt-2 mb-2"
                type="link"
                as={Link}
                to={`/participant-awards/${participant._id}`}
              >
                Awards <MdStars />
              </Button>
            )}
          </div>
        </Col>
      </Row>
      {participant.Subscriptions.length > 0 && (
        <Row>
          <Col>
            <div className="shadow mt-4 p-3 border">
              <h3 className="text-center">
                Manage {`${participant.First_Name}'s `}Classes
              </h3>
              <Row>
                {" "}
                {participant.Subscriptions.map((subscription) => (
                  <Col key={subscription._id} sm="12" lg={largeCols}>
                    <div className="shadow mt-2 p-3 border text-center">
                      <h6>{`${subscription.ClassLessonType} (${subscription.ClassDay})`}</h6>
                      <hr />
                      <small>{subscription.StripeStatus}</small>
                      <hr />
                      <Button
                        variant="info"
                        size="sm"
                        className="w-100 mt-1 mb-1"
                        as={Link}
                        to={`/class-info/${subscription.ClassID}`}
                      >
                        Info <MdSearch />
                      </Button>
                      <hr />
                      <Button
                        variant="primary"
                        size="sm"
                        className="w-100 mt-1 mb-1"
                        onClick={(e) =>
                          handleCardChange(
                            subscription.stripe_subscription_id,
                            e
                          )
                        }
                        disabled={
                          subscription.StripeStatus ===
                            "Last Payment / Cancelled" ||
                          subscription.StripeStatus === "Payment Past Due" ||
                          props.submitClicked
                        }
                      >
                        Change Card <MdCreditCard />
                      </Button>
                      <hr />
                      <Button
                        variant="danger"
                        size="sm"
                        className="w-100 mt-1 mb-1"
                        onClick={(e) => {
                          setCancellationIsOpen(true, e);
                          setCancellingSub(subscription.stripe_subscription_id);
                        }}
                        disabled={
                          subscription.StripeStatus ===
                            "Last Payment / Cancelled" ||
                          subscription.StripeStatus === "Payment Past Due" ||
                          props.submitClicked
                        }
                      >
                        Leave <MdCancel />
                      </Button>
                    </div>
                    <CancellationModal
                      setCancellingSub={setCancellingSub}
                      cancellationIsOpen={cancellationIsOpen}
                      setCancellationIsOpen={setCancellationIsOpen}
                      cancelSubscription={cancelSubscription}
                      selfCancellation={selfCancellation}
                    />
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>
      )}

      {participant.BlockClasses.length > 0 && (
        <Row>
          <Col>
            <div className="shadow mt-4 p-3 border">
              <h3 className="text-center">
                Manage {`${participant.First_Name}'s `}Blocks
              </h3>
              <Row>
                {" "}
                {participant.BlockClasses.map((block) => (
                  <Col key={block._id} sm="12" lg={largeColsBlock}>
                    <div className="shadow mt-2 p-3 border text-center">
                      <h6>{block.LessonType}</h6>
                      <hr />
                      <Button
                        variant="info"
                        size="sm"
                        className="w-100 mt-1 mb-1"
                        as={Link}
                        to={`/block-info/${block._id}`}
                      >
                        Info <MdSearch />
                      </Button>
                      <hr />
                      <Button
                        variant="danger"
                        size="sm"
                        className="w-100 mt-1 mb-1"
                        onClick={(e) => {
                          setBlockCancellationIsOpen(true, e);
                          setCancellingBlock({
                            blockID: block._id,
                            participantID: participant._id,
                          });
                        }}
                      >
                        Leave <MdCancel />
                      </Button>
                    </div>
                    <BlockCancellationModal
                      setCancellingBlock={setCancellingBlock}
                      blockCancellationIsOpen={blockCancellationIsOpen}
                      setBlockCancellationIsOpen={setBlockCancellationIsOpen}
                      cancelBlock={cancelBlock}
                      selfCancellation={selfCancellation}
                    />
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>
      )}

      {participant.WaitingList.length > 0 && (
        <Row>
          <Col>
            <div className="shadow mt-4 p-3 border">
              <h3 className="text-center">
                {`${participant.First_Name}'s `}Waiting Lists
              </h3>
              {participant.WaitingList.map((waitingList) => (
                <Col key={waitingList._id} sm="12" lg={largeColsWaiting}>
                  <div className="shadow mt-2 p-3 border text-center">
                    <h6>{`${waitingList.ClassLessonType} (${waitingList.ClassDay})`}</h6>
                    <hr />
                    {waitingList.Status === "new" ? (
                      <Button
                        variant="danger"
                        size="sm"
                        className="w-100 mt-1 mb-1"
                        onClick={(e) => cancelWaitingList(waitingList._id, e)}
                        disabled={props.submitClicked}
                        type="button"
                      >
                        Cancel <MdCancel />
                      </Button>
                    ) : waitingList.Status === "Offered" ? (
                      <Button
                        variant="primary"
                        size="sm"
                        className="w-100 mt-1 mb-1"
                        type="link"
                        as={Link}
                        to={`/waswaiting/${waitingList.ClassID}/${waitingList.ParticipantID}`}
                      >
                        Subscribe <MdCheckCircle />
                      </Button>
                    ) : (
                      <Button
                        variant="warning"
                        size="sm"
                        className="w-100 mt-1 mb-1"
                        onClick={(e) => cancelWaitingList(waitingList._id, e)}
                        disabled={props.submitClicked}
                      >
                        Expired <MdCancel />
                      </Button>
                    )}
                  </div>
                </Col>
              ))}
            </div>
          </Col>
        </Row>
      )}

      <div className="mt-2 mb-2">
        <StatusBlock
          errorMessage={props.errorMessage}
          successMessage={props.successMessage}
          dismissMessages={props.dismissMessages}
        />
      </div>
    </FadeIn>
  );
};

const CancellationModal = (props) => {
  return (
    <Modal
      show={props.cancellationIsOpen}
      size="lg"
      onHide={(e) => {
        props.setCancellationIsOpen(false, e);
        props.setCancellingSub("");
      }}
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>Want to cancel?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.selfCancellation && (
          <p>
            <strong>
              ATTENTION: This will cancel your subscription from the end of this
              month, not immediately.
            </strong>{" "}
            If you want to transfer or change your class, you should{" "}
            <strong>not</strong> use this button. If you wish to move class, you
            should contact us directly to move your subscription to another
            time.
          </p>
        )}
        {!props.selfCancellation && (
          <p>
            <strong>
              PLEASE CONTACT US DIRECTLY TO CANCEL THIS SUBSCRIPTION:
            </strong>{" "}
            Our terms and conditions require you to contact us directly to
            cancel your subscription, for example because your cancellation
            might not be within our minimum notice period.
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          size="lg"
          onClick={(e) => {
            props.setCancellationIsOpen(false, e);
            props.setCancellingSub("");
          }}
        >
          Close
        </Button>
        <Button
          variant="danger"
          size="lg"
          onClick={(e) => props.cancelSubscription(e)}
          disabled={!props.selfCancellation}
        >
          Leave Class
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const BlockCancellationModal = (props) => {
  return (
    <Modal
      show={props.blockCancellationIsOpen}
      size="lg"
      onHide={(e) => {
        props.setBlockCancellationIsOpen(false, e);
        props.setCancellingBlock("");
      }}
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>Want to cancel?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>
            ATTENTION: This block has been paid in full for the remaining dates.
          </strong>{" "}
          If you feel you require a refund or want to change dates / times to an
          alternative block you should contact us directly.{" "}
          {props.selfCancellation && "You can leave the block now if you wish."}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          size="lg"
          onClick={(e) => {
            props.setBlockCancellationIsOpen(false, e);
            props.setCancellingBlock("");
          }}
        >
          Close
        </Button>
        <Button
          variant="danger"
          size="lg"
          onClick={(e) => props.cancelBlock(e)}
          disabled={!props.selfCancellation}
        >
          Leave Block
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ParticipantManageBlock;
